import React from 'react'
import { PaginaNode } from '@gql/graphql'
import { ListingItemtype } from '@utils/types'
import { GenericHero, Page, Prefooter, ProgettiListing } from 'components/organisms'
import styles from './ProgettiHubTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  listing?: ListingItemtype
}

const ProgettiHubTemplate = (props: Props) => {
  const { pagina = undefined, listing = undefined } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <ProgettiListing listing={listing} />
        <Prefooter />
      </main>
    </Page>
  )
}

export default ProgettiHubTemplate
